import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45f2c3c8")

_pushScopeId("data-v-45f2c3c8")
const _hoisted_1 = { class: "guide df-middle bg-primary f-bold p-a" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Seize market opportunities ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DemoAccountTip = _resolveComponent("DemoAccountTip")
  const _component_TheTopMovers = _resolveComponent("TheTopMovers")
  const _component_TheWatchListSp = _resolveComponent("TheWatchListSp")
  const _component_WTTabs = _resolveComponent("WTTabs")
  const _component_t = _resolveComponent("t")
  const _component_TheDepositTip = _resolveComponent("TheDepositTip")
  const _component_Icon = _resolveComponent("Icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_AccountRelated = _resolveComponent("AccountRelated")
  const _component_Page = _resolveComponent("Page")

  return (_openBlock(), _createBlock(_component_Page, { class: "trade df-col bg-white" }, {
    default: _withId(() => [
      _createVNode(_component_DemoAccountTip),
      _createVNode(_component_TheTopMovers),
      _createVNode(_component_t, { custom: "" }, {
        default: _withId(({ t }) => [
          _createVNode(_component_WTTabs, {
            class: "fill flex-1",
            "nav-class": "wt-nav px-4",
            "tab-class": "wt-tab-nav",
            tabs: [t('market_2'), t('market_43')]
          }, {
            default: _withId(() => [
              _createVNode(_component_TheWatchListSp),
              _createVNode(_component_TheWatchListSp, { isAll: true })
            ]),
            _: 2
          }, 1032, ["tabs"])
        ]),
        _: 1
      }),
      _createVNode(_component_TheDepositTip, {
        class: "p-a",
        style: {"bottom":"0","left":"0","right":"0"}
      }),
      _createVNode(_component_AccountRelated, { "use-in-roam": "" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_Icon, {
              name: "person-plus",
              class: "mr-6"
            }),
            _createVNode(_component_t, {
              path: "market_12",
              class: "flex-1"
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/login",
              class: "reg_btn"
            }, {
              default: _withId(() => [
                _createVNode(_component_t, {
                  path: "market_13",
                  custom: ""
                }, {
                  default: _withId(({td}) => [
                    _createTextVNode(_toDisplayString(td || 'Sign up'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})